module.exports = __webpack_public_path__ + "img/m2g_event_notice.4c875a18.png";